import styles from './History.module.scss'
import React, { useRef } from 'react'
import BasicTitle from 'components/about/BasicTitle/BasicTitle'
import animationStyles from 'components/commons/Animation/Animation.module.scss'
import useElementVisible from 'components/commons/Animation/useElementVisible'

interface HistoryItem {
  year: number
  event: string[]
  last?: boolean
}

const historyItems: HistoryItem[] = [
  {
    year: 2006,
    event: ['渋谷区松濤に株式会社アイスリーデザインの商号にて渋谷に登記'],
  },
  {
    year: 2009,
    event: ['日本企業の海外進出/輸出を支援するITサービスを事業譲渡により売却'],
  },
  {
    year: 2010,
    event: ['ケニア共和国にてIT会社を設立するも撤退'],
  },
  {
    year: 2011,
    event: ['第2創業、スマホ変換のクラウドサービス”SMARTCONVERT”を発表'],
  },
  {
    year: 2012,
    event: ['事業拡張に伴い渋谷区神宮前にオフィス移転'],
  },
  {
    year: 2013,
    event: ['事業拡張に伴い青山にオフィス移転', 'i3DESIGN-UKRAINE,LLC設立'],
  },
  {
    year: 2014,
    event: ['クラウドサービス”flamingo”を発表', 'UI/UXデザインサービスを開始'],
  },
  {
    year: 2015,
    event: [
      'Mobile World Congress in Barcelona 2015に出展',
      'アプリPUSH配信エンジン”ZEBRA”を発表',
      'AWSテクノロジーパートナーに加入',
      '海外のアプリ開発者間のアプリソース売買サイト”meetsource.com”OPEN',
    ],
  },
  {
    year: 2016,
    event: ['AMP対応クラウドサービス”Rabbit”を発表'],
  },
  {
    year: 2019,
    event: ['CI/ロゴを刷新'],
  },
  {
    year: 2020,
    event: [
      'VR/AR/ゲーム開発のソリッドスフィア株式会社をグループ会社化',
      'ライフスタイルカルチャーメディア”Quiiver（クイーバー）”OPEN',
      'アプリソース売買サイト”meetsource.com” CLOSE',
    ],
  },
  {
    year: 2021,
    event: [
      '株式会社DG Daiwa Ventures、みずほキャピタル株式会社より総額2億円の資金調達',
      'SDGs-スポーツDX支援"KNOT online contest"を開催',
    ],
  },
  {
    year: 2022,
    event: ['DX組織実現のための超実践型ワークショップ', '“ヒューマンイノベーションプログラム”を開始'],
  },
  {
    year: 2023,
    event: [
      'メタバース・xRを手がけるグループ会社のソリッドスフィア株式会社を統合',
      '事業拡張に伴い青山一丁目にオフィス移転',
    ],
  },
  {
    year: 2026,
    event: [
      '社名をAitria株式会社へ変更（効力発生日：2026年11月4日）',
      'i3の「3」（AI／DESIGN／ENGINEER）をtriaの「3」へ継承し、Design × AI × Engineeringを統合するAI駆動のデジタルエンジニアリング企業として次の段階へ',
    ],
    last: true,
  },
]

const History: React.FC = () => {
  const imgRef = useRef<HTMLDivElement | null>(null)
  const isVisible = useElementVisible(imgRef, 0.1)

  const list = historyItems.map(
    ({ year, event, last }): JSX.Element => (
      <li key={year} className={`${styles.story} ${last && styles.story_last}`}>
        <div className={styles.year_container}>
          <div className={styles.container}>
            <span className={styles.year}>{year}</span>
          </div>
        </div>
        <div className={styles.border_container}>
          <div className={styles.border_middle}></div>
        </div>
        {((): JSX.Element => {
          const items = []
          for (let i = 0; i < event.length; i++) {
            items.push(<p key={event[i]}>{event[i]}</p>)
          }
          return (
            <div className={styles.container}>
              <div className={styles.text}>{items}</div>
            </div>
          )
        })()}
      </li>
    ),
  )

  const sectionTitle = {
    title: 'History',
    sub_title: '会社沿革',
  }

  return (
    <section className={`${styles.contents} history_wrapper`} id="history_top">
      <div className={styles.contents_wrapper}>
        <div className={styles.title_group}>
          <BasicTitle sectionTitle={sectionTitle} />
        </div>
        <div
          className={`${styles.content} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
          ref={imgRef}
        >
          <ul className={styles.history_group}>{list}</ul>
        </div>
      </div>
    </section>
  )
}

export default History
